import { useTLang } from 'intl/intl';

export function useMenuItemFinderLang() {
  return {
    header: {
      title: useTLang({ id: 'substitutionFlow.037' }),
    },
    main: {
      title: useTLang({ id: 'substitutionFlow.038' }),
    },
    input: {
      first: {
        placeholder: useTLang({ id: 'substitutionFlow.011' }),
      },
      second: {
        placeholder: useTLang({ id: 'substitutionFlow.012' }),
      },
    },
  };
}
